import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const ChartPieAlt = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 12H12V5C12 4.4 11.6 4 11 4C6 4 2 8 2 13C2 18 6 22 11 22C16 22 20 18 20 13C20 12.4 19.6 12 19 12ZM15 2C14.4 2 14 2.4 14 3V9C14 9.6 14.4 10 15 10H21C21.6 10 22 9.6 22 9C22 5.1 18.9 2 15 2ZM16 8V4.1C18 4.5 19.5 6 19.9 8H16Z"
      fill="currentColor"
    />
  </svg>
)

export default ChartPieAlt
